import util             from 'util/Util.js';
import formulaService   from 'xml/FormulaService.js';
import specialFormList  from 'SpecialFormList.js';
import listService      from 'ListService.js';
import namesUtil        from 'util/NamesUtil.js'
import constants    from  'Constants';
import eventBus     from 'EventBus';

//==================================================================
// Utility methods for widgets
//==================================================================
class WidgetUtil {

    getWidgetText(model) {
        let widgetText = '';
        if (!util.isTrue(model.get('autosummary'))){
            widgetText = model.get('summary');
        } else {
            let factoryKey = model.get('factoryKey');
            switch (factoryKey) {
                case 'command_simple_branch':
                case 'command_multiple_branch':
                    if (model.get('Parameters')){
                        widgetText = formulaService.convertExpressionToText(
                                        model.get('Parameters').Parameter[0].Expression);

                    } else {
                        widgetText = '?';
                    }
                    break;
                case 'command_close':
                case 'command_submit_data':
                    widgetText = this.getAutosummaryForClose(model.get('closeOption'));
                    break;
                case 'command_cancel_notification':
                    if (model.get('cancelNotificationType') === '2') {
                        widgetText = 'All';
                    } else {
                        widgetText = model.get('cancelNotificationName');
                    }
                    break;
                 case 'command_set_state':
                    widgetText = this.getObjectCount(model);
                    break;
                 case 'command_notify':
                    widgetText = this.getNotificationsCount(model);
                    break;
                 case 'command_copy_field_values':
                    let count = 0;
                    if(model.get('Property')[0].Item){
                      count = 1;
                      if(Array.isArray(model.get('Property')[0].Item)){
                        count = model.get('Property')[0].Item.length;
                      }
                    }
                    widgetText = count + ' fields';
                    break;
                 case 'command_show_message':
                 case 'command_show_url':
                    widgetText = this.getAutosummaryForSelectedValue(model);
                    break;
                 case 'command_show_page':
                    widgetText = this.getAutosummaryForSelectedPage(model);
                    break;
                 case 'command_connect':
                 case 'command_connect_search':
                    if (model.get('connectionName')) {
                        widgetText = model.get('connectionName');
                    }
                    break;
                 case 'command_show_form':
                 case 'command_get_field_from_other':
                 case 'command_set_field_in_other':
                    widgetText = model.get('formName');
                    break;
                 case 'command_show_report':
                    widgetText = model.get('reportName');
                    break;
                 case 'command_call_javascript':
                    widgetText = model.get('function');
                    break;
                 case 'command_set_field_value':
                    if (model.get('fieldId')){
                        widgetText = namesUtil.determineFieldName(model.get('fieldId'));
                    }
                    break;
                 case 'command_set_selection_items':
                    if (model.get('controlId')){
                        widgetText = namesUtil.determineFieldName(model.get('controlId'));
                    }
                    break;
                 case 'command_start_stop':
                    if (model.get('controlId')) {
                        const obj = listService.getObject( listService.cleanId(model.get('controlId')) );
                        widgetText = obj ? obj.model.get('name') : '';
                    }
                    break;
                 case 'command_set_next_stage':
                    if (model.get('stageId')) {
                        const obj = listService.getWorkflowStageByID( model.get('stageId') );
                        widgetText = obj? obj.model.get('name') : 'Unspecified';
                    } else {
                        widgetText = 'Unspecified';
                    }
                    break;
              case 'command_check_obligatory':
                    let objectCount = 0;
                    let items;
                    if (Array.isArray(model.attributes.Property)) {
                        items = model.attributes.Property[0].Item;
                    } else {
                        items = model.attributes.Property.Item;
                    }
                    
                    if (Array.isArray(items)) {
                        objectCount = 0;
                        items.forEach(function(item){
                            //PF-7079 Added validation because group-values were not being counted
                            let objName = item._value.indexOf("$") > -1 ? item._value.replace('$v','') : item._value;

                            //PF-5192 added validation to check if objects exists before counting them for backwards compatibility
                            let objId = listService.cleanId(objName);                            
                            if(listService.getObject(objId)){
                                objectCount++;
                            }
                        });                        
                    }else if (items){
                        objectCount = 1;
                    }
                    
                    widgetText = objectCount + (objectCount === 1 ? ' object' : ' objects');
                    break;
              case 'workflow_stage':
                    widgetText = model.get('description');
                break;
              case 'control_clear_filter':
                  //PF-2818
                  const currentDataSourceId = model.get('dataSourceId');
                  if(!currentDataSourceId){
                      let firstDataSource=listService.getDataSources().first();

                      // PF-2818 Default Autosummary Checked if DataSources are available.
                      if(firstDataSource &&
                          (model.get('autosummary') === 'true' || model.get('autosummary') === true) ){
                          let cleanDataSourceId= firstDataSource ? listService.cleanId(firstDataSource.id) : undefined;
                          //always add origina data source id to models
                          model.set('dataSourceId', listService.getCleanedId(cleanDataSourceId),{silent:true});
                          listService.setReportingMetaData(cleanDataSourceId,model,true);
                          widgetText = firstDataSource.name;
                      }else{
                          widgetText=model.get('summary');
                      }
                  }
                  else if(currentDataSourceId && currentDataSourceId !== 'none'){
                      widgetText =
                            listService.getDataSources(listService.cleanId(currentDataSourceId))['name'];
                  }
                  else{
                      widgetText="";
                  }
                break;
              case 'control_set_filter':
                if (model.get('dataSourceId') && model.get('fieldId') && model.get('fieldId') !== 'none' ) {
                    const ds = listService.getDataSources(listService.cleanId(model.get('dataSourceId')) );
                    let i = 0;

                    if (ds) {
                        let dsArray = ds.Fields.Field;
                        do {
                            if (dsArray[i].id === model.attributes.fieldId) {
                                if (parseInt(dsArray[i].oldId)) {
                                    widgetText = dsArray[i].name;
                                }else {
                                    widgetText = dsArray[i].name;
                                    widgetText = this.translateDSField(dsArray[i].id);
                                }
                            }
                            i++;
                        } while (i<= dsArray.length && widgetText==='');
                    }
                }
                break;
               case 'command_set_table_rows':
               case 'command_show':
                if (model.get('controlId')) {
                    const id = model.get('controlId');
                    let object = listService.getObject( listService.cleanId(id)) ?
                            listService.getObject( listService.cleanId(id)) :
                        // PF-2163 Searching through pages also.
                            listService.getPage( listService.getObjectByCleanedId(id) );
                    widgetText = object ? object.model.get('name') : '';
                }
                break;
                case 'command_run':
                    widgetText = model.get("script");
                break;
                case 'command_transaction':
                    widgetText = model.get("connection");
                break;
                case 'command_set_properties':
                    widgetText = model.get("propertyFieldSelected");
                break;
                
            default: break;
            }
        }
        return widgetText;
    }

    translateDSField(text) {
        let fname = text;
        switch (text.toLowerCase()) {
            case 'CreateDate'.toLowerCase():
                fname = 'Meta - Last Submission Date';
                break;
            case 'E'.toLowerCase():
                fname = 'Meta - Instance Number';
                break;
            case 'FormInstanceGUID'.toLowerCase():
                fname = 'Meta - Instance ID';
                break;
            case 'FormInstanceId'.toLowerCase():
                fname = 'Meta - Link';
                break;
            case 'MajorVersion'.toLowerCase():
                fname = 'Meta - Version Major';
                break;
            case 'MinorVersion'.toLowerCase():
                fname = 'Meta - Version Minor';
                break;
            case 'Name'.toLowerCase():
                fname = 'Meta - Instance Name';
                break;
            case 'ParentGUID'.toLowerCase():
                fname = 'Meta - Parent Instance ID';
                break;
            case 'StageName'.toLowerCase():
                fname = 'Meta - Stage';
                break;
            default:
                break;
        }
        return fname;
    }

    getAutosummaryForClose(option) {
        let text = '';
        switch (option) {
            case 'newInstance':
                text = 'Open New Instance';
                break;
            case 'sameInstance':
                text = 'Re-Open Same Instance';
                break;
            case 'closeBrowser':
                text = 'Close Browser';
                break;
            case 'showURL':
                text = 'Redirect to a URL';
                break;
        }
        return text;
    }

    getAutosummaryForSelectedValue(model){
        let text = '';
        if (model.get('Parameters')){
            let type = model.get('Parameters').Parameter[0].type;
            switch (type){
                case 'literal':
                    text = model.get('Parameters').Parameter[0].literal;
                    break;
                case 'field':
                    const id = model.get('Parameters').Parameter[0].field;
                    const obj = listService.getObject( listService.cleanId(id) );
                    if (obj) {
                        text = obj.model.get('name');
                    }
                    break;
                case 'special':
                    const special = model.get('Parameters').Parameter[0].special;
                    const specialList = specialFormList.getSpecialFormList();
                    const specialValue = specialList.filter(function (el) {
                          return el.value === special;
                        });
                    text = specialValue[0].text;
                    break;
                case 'expression':
                    let expression =  model.get('Parameters').Parameter[0].Expression;
                    if (expression) {              
                       text = formulaService.convertExpressionToText(expression);
                    }
                    break;
                default: break;
            }
        }
        return text;
    }

    getAutosummaryForSelectedPage(model){
        let pageType = model.get('pageType');
        let text = '';
        if (pageType === 'specific'){
            const selectedPage = listService.pageList.filter( function (obj){
                return listService.getCleanedId(obj.model.get('id')) === model.get('page');
            });
            text = selectedPage.size ? selectedPage.first().model.get('name') : '';
        } else {
            text = pageType.charAt(0).toUpperCase() + pageType.substring(1)
        }
        return text;
    }

    getNotificationsCount(model){
        const notifications = model.get('notifications');
        let count = 0;
        if (notifications){
            count = notifications.length;
        }
        return count + ' objects';
    }


    getObjectCount(model){
        let text = '';
        if ( model.attributes.Property ){
            const controls = _.find(model.attributes.Property, function(obj) { return obj._id === 'controls' });
            if (controls.Item instanceof Array){
                let ct = 0;
                let name = '';
                for (var i = 0; i < controls.Item.length; i++) {
                    const id = controls.Item[i]._value;
                    let obj = listService.getObject(listService.cleanId(id));
                    if (!obj) {
                        obj = listService.getPage(listService.cleanId(id))
                    }
                    if (obj) {
                        name = obj.model.get('name');
                        ct++;
                    }
                }
                text = ct + ' objects';
            } else {
                if (controls.Item) {
                    const id = controls.Item._value;
                    let obj = listService.getObject(listService.cleanId(id));
                    if (!obj) {
                        obj = listService.getPage(listService.cleanId(id))
                    }
                    let name = obj ? obj.model.get('name') : '';
                    text= name;
                }
            }
        }
        return text;
    }


    // PF-2345
    removeAllBezeierControlPoints(wantDelselectPath = true) {
        listService.isDraggingCp = false;
        const fcanvas = listService.fcanvas;
        fcanvas.renderOnAddRemove = false;

        fcanvas.forEachObject( w => {
            if (w && w.pfKind && w.pfKind === constants.CONTROL_PT) {
                fcanvas.remove(w);
            }
        });
        if (wantDelselectPath) {
            listService.currentSelectedPathId = undefined;
        }
    }

    //==================================================================================================================
    // This is s curved-line-specific hit test. Returns no hit if given any other kind of object.
    // Params:
    //  w: a bezier 'connection_arrow' object assumed to contain a hitTestBezier method.
    //  evt: an event that needs at least offsetX and offSetY, used as a mouse click point
    //==================================================================================================================
    isBezierHit( w, evt ){
        let isHit = false;

        if (!listService.currentSelectedPathId) {
            if (!isHit) {
                const fcanvas = listService.fcanvas;
                if (fcanvas.getActiveObject() !== w && w.hitTestBezier && w.model &&
                    w.model.get('factoryKey') === 'connection_arrow' && w.model.get('lineType') === 'bezier') {

                    // Mouse pt in object coordinates:
                    const mousePt = w.makePoint(evt.offsetX - w._xOffset(), evt.offsetY - w._yOffset());
                    isHit = w.hitTestBezier(mousePt);
                }

                // Process a hit
                if (isHit) {
                    this.processPathHit(w);
                }
            }
        }
        return isHit;
    }

    isCurvedLineHovered(w, evt){
        // Mouse pt in object coordinates:
        const mousePt = w.makePoint(evt.offsetX - w._xOffset(), evt.offsetY - w._yOffset());
        return w.hitTestBezier(mousePt);
    }

    checkCurvedLineIfHovered(object) {
        if (!listService.currentSelectedPathId) {
            if (object.e) {
                listService.fcanvas.forEachObject(w => {
                    if (w.model && w.model.get('lineType') === 'bezier' && this.isCurvedLineHovered(w, object.e)){
                         object.target = w;
                    }
                });
            }
        }
    }

    checkAllObjectsIfHit(object) {
        // Handle event on next turn:
        let isHit = false;
     
        // Whenever possible, skip unneeded hit tests.
        // FabricJS object mouse event in workflow page or behavior page may have already selected a connection path;
        if (!listService.currentSelectedPathId) {

            // A drop of a stage, etc has no ev.e. Otherwise, check if mouse-up within range of a bezier curved path, etc.
            if (object.e) {

                // Look for first Bezier in the crowd that touches the mouse point. May be none.
                listService.fcanvas.forEachObject(w => {

                    if (this.isClickedBalloon(w, object.e)) {
                        object.target = w;
                    } else if (!isHit && w.model && w.model.get('lineType') === 'bezier') {
                        if(this.isBezierHit(w, object.e)){
                            object.target = w;
                        }
                    }
                });
            }
        }
    }

    //==================================================================================================================
    // w is a path to be selected. Carry out standardized processing to select a path here:
    //==================================================================================================================
    processPathHit(w) {
        const fcanvas = listService.fcanvas;
        this.removeAllBezeierControlPoints();
        fcanvas.setActiveObject(w);
        const eventKind = listService.mainKind === 'W'
            ? 'selectWorkflowConnection'
            : (listService.mainKind === 'B' ? 'selectBehaviorConnection' : null);
        eventBus.trigger(eventKind, w);
        fcanvas.renderAll();
        setTimeout(() => fcanvas.renderAll(), 0);
    }

    //==================================================================================================================
    // If mouse point is within a path (w) model's marker or caption balloon-bubble, select the path.
    // Called by a mouse event handler.
    //==================================================================================================================
    isClickedBalloon(w, evt) {
        // If it is a path with a balloon, return true  if mouse point within it
        const hasBalloon = w.model && w.model.has('lineType')
            && (w.model.get('hasNotifications') || w.model.get('hasConditions')
                || w.model.get('hasScripts') || w.model.get('name'));

        if (hasBalloon) {
            const ma = w.model.attributes;
            const maxWidth = Number(w.model.get('textBoxWidth')) || 100;

            // Mouse pt
            const mp = w.makePoint(evt.offsetX, evt.offsetY);

            const lineY = 0; // Maybe placeholder for smarter Y.
            let height = (20 + lineY) + 20;

            // PF-2345 Curved line label position is midpoint of virtual line joining the Bezier control points, but
            // straight line caption position is midpoint of the actual path.
            const cl = (ma.lineType === 'bezier') ? w.computeCpMid(w.model) : {x: 0, y: 0};

            // Balloon rect in offset coordinates
            const r = {};
            r.x = cl.x - (maxWidth / 2) + w._xOffset();
            r.y = cl.y - 14 + w._yOffset();
            r.width = maxWidth;
            r.height = height;

            // Is mount point contained in balloon rect?
            const isHit = (mp.x > r.x) && (mp.x < r.x + r.width) && (mp.y > r.y) && (mp.y < r.y + r.height);

            /*console.log(`isClickedBalloon offsetX: ${evt.offsetX}, offsetY: ${evt.offsetY}`);
            console.log(`isClickedBalloon model`, ma);
            console.log(`isClickedBalloon mouse`, mp);
            console.log(`isClickedBalloon rect`, r);
            console.log(`isClickedBalloon isHit`, isHit);
            console.log('*************');*/

            // Process a hit - light up the path and show its properties
            if (isHit) {
                this.processPathHit(w);
            }

            return isHit;
        }
    }

}
const widgetUtil = new WidgetUtil();
export default widgetUtil;
